import { configureHtmxHistory, initAppEventWiring } from "./modules/app_events.js";

configureHtmxHistory();
initAppEventWiring();
